// src/components/CartIcon.js
import {React ,useMemo}from "react";
import { useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { useCart } from "../../context/cartContext";
import { useSite } from "../../context/siteContext"; // Add this import
import { ROUTES } from "../../constants";
import { Button, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

function CartIcon({ onOpen }) {
    const { cartItems } = useCart(); 
    const { selectedSite, selectedSiteData, selectedSiteKey } = useSite();
    // const navigate = useNavigate();
    const { t } = useTranslation();

    // Use the working manual calculation
    const actualCount = useMemo(() => {
        const selectedScopeKey = String(selectedSiteKey || "").trim() ||
            ((selectedSiteData?.site_id && selectedSiteData?.cus_id)
                ? `${selectedSiteData.site_id}:${selectedSiteData.cus_id}`
                : "");
        const filteredItems = (cartItems || []).filter((item) => {
            const itemSiteId = String(item?.site_id ?? item?.siteId ?? "").trim();
            const itemCusId = String(item?.cus_id ?? item?.customer_id ?? item?.customerId ?? "").trim();
            const itemScopeKey = itemSiteId && itemCusId ? `${itemSiteId}:${itemCusId}` : "";
            if (selectedScopeKey && itemScopeKey) return itemScopeKey === selectedScopeKey;
            if (selectedScopeKey && !itemScopeKey) return false;
            return String(item?.Site ?? "") === String(selectedSite ?? "");
        });
        return filteredItems.reduce((sum, item) => sum + (parseInt(item.Quantity) || 0), 0);
    }, [cartItems, selectedSite, selectedSiteData?.site_id, selectedSiteData?.cus_id, selectedSiteKey]);

    // const handleClick = () => {
    //     navigate(ROUTES.CART);
    // };

    // Show correct count with 99+ limit
    const displayCount = actualCount >= 99 ? "99+" : actualCount;

    return (
        <Tooltip title={t("UI_TEXT.TOOLTIP_CART")} arrow placement="bottom">
            <Badge
                    badgeContent={displayCount}
                    color="primary"
                showZero={true}
                sx={{ '& .MuiBadge-badge': { right: 10, top: 2, fontSize: '11px' } }}
                >
                <IconButton color="primary" onClick={onOpen} sx={{ mr: 1 }}>
                    <ShoppingCartOutlinedIcon />
                </IconButton>

            </Badge>

        </Tooltip>
    );
}

export default CartIcon;
